<template>
  <form @submit="handleImport($event)">
    <div class="row">
      <div class="col-md-12 pt-0 pb-0">
        <!-- <p class="m-0 worksansr">Extrato bancário .OFX</p> -->
        <!-- <ol class="pl-5">
          <li>Abra uma nova janela e entre no site do seu banco.</li>
          <li>
            Exporte seu extrato bancário para o formato .OFX do período
            desejado.
          </li>
        </ol> -->
        <p class="m-0 worksansr">Arquivo .xls</p>
        <ol class="pl-5">
          <li class="m-0 p-0 d-flex align-items-center">
            <v-btn small class="btn-edit mr-2" @click="downloadXls"
              >Baixe o arquivo modelo aqui!</v-btn
            >
            <h6 class="c-warning">
              A ordem do nome das colunas deve ser exatamente identica ao
              arquivo modelo!
            </h6>
          </li>
          <li class="m-0 p-0">
            Preencha os dados conforme a descrição das colunas do arquivo.
          </li>
        </ol>
      </div>
      <div class="col-md-12 pt-0 pb-0">
        <LabelRequiredField label="Importar na conta" />
        <select
          :disabled="loading"
          class="form-control"
          v-model="finance_configuration_account_id"
        >
          <option value="">SELECIONE UMA CONTA BANCÁRIA...</option>
          <option
            v-for="account in finance_configuration_account"
            :key="account.id"
            :value="account.id"
          >
            {{ account.account_nickname }}
          </option>
        </select>
      </div>
      <div class="col-md-12 pt-0 pb-0">
        <LabelRequiredField label="Arquivo" />
        <b-form-file
          name="file"
          :disabled="loading"
          placeholder="SELECIONE OU ARRASTE O ARQUIVO AQUI CSV."
          drop-placeholder="SOLTE O ARQUIVO AQUI..."
          browse-text="PROCURAR"
          accept=".csv"
          id="file"
        />
      </div>
      <div class="col-md-12">
        <div class="v-warning p-2">
          <p class="worksansr m-0">
            Recomendamos importar no máximo 200 lançamentos por vez.
          </p>
          <!-- <p class="worksansr m-0">
            Caso seja um extrato bancário, tente exportar um período menor.
          </p> -->
        </div>
      </div>
      <div class="col-md-12 pt-0 pb-0"><ErrorsMessages :errors="errors" /></div>
      <div class="col-md-12 text-right">
        <v-btn :disabled="loading" type="submit" class="btn-save">
          <i class="fas fa-check mr-2 text-twenty"></i>
          {{ loading ? "CARREGANDO" : "IMPORTAR" }}
        </v-btn>
      </div>
    </div>
  </form>
</template>

<script>
import ErrorsMessages from "../../../Components/ErrorsMessages";

import LabelRequiredField from "../../../Components/LabelRequiredField";

import toast from "../../../../lib/ToastNotification";

import api from "../../../../services/api";

import moment from "moment";

export default {
  name: "Import",
  components: {
    ErrorsMessages,
    LabelRequiredField,
  },
  props: {
    finance_configuration_account: Array,
  },
  data() {
    return {
      json_data: [],
      finance_configuration_account_id: "",
      loading: false,
      errors: [],
    };
  },
  created() {
    this.retrieve();
  },
  methods: {
    downloadXls() {
      var items = this.json_data;
      let replacer = (key, value) => (value === null ? "" : value);
      let header = Object.keys(items[0]);
      let csv = items.map((row) =>
        header
          .map((fieldName) => JSON.stringify(row[fieldName], replacer))
          .join(";")
      );
      csv.unshift(header.join(";"));
      csv = csv.join("\r\n");

      let link = document.createElement("a");

      link.setAttribute(
        "href",
        `data:text/csv;charset=utf-8,%EF%BB%BF${encodeURIComponent(csv)}`
      );
      link.setAttribute("download", "Exemplo.csv");
      link.style.visibility = "hidden";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    retrieve() {
      let json_data = [];

      let types = ["CREDITO", "DEBITO"];

      for (let type of types) {
        json_data.push({
          "Data de vencimento": moment().format("DD/MM/YYYY"),
          Descrição: "Descrição",
          Valor: type == "CREDITO" ? "R$ 10,00" : "R$ -10,00",
          Categoria: "Categoria",
          "Forma de pagamento": "Depósito",
          "Data de pagamento": moment().format("DD/MM/YYYY"),
          "Cliente/Fornecedor":
            type == "CREDITO" ? "Nome do Fornecedor" : "Nome do Cliente",
          "Centro de custo/lucro": "Investimento",
          "Custo nível de produção": type == "CREDITO" ? "Fixo" : "Variavel",
          "Custo apropriação do produto":
            type == "CREDITO" ? "Direto" : "Indireto",
          Observação: "",
          "Tipo de documento": "",
          "Data competência": moment().format("DD/MM/YYYY"),
          Conta: "Conta bancária",
          Tags: type == "CREDITO" ? "Tag1, Tag2" : "Tag1",
          "Conta que transferiu": "",
          "Conta que recebeu a transferência": "",
        });
      }

      this.json_data = json_data;
    },
    async handleImport(event) {
      try {
        event.preventDefault();

        this.loading = true;

        this.errors = [];

        const formData = new FormData();

        let files = document.getElementById("file").files;

        let { finance_configuration_account_id } = this;

        if (!finance_configuration_account_id) {
          this.loading = false;
          this.errors = ["Informe a conta"];
          return;
        }

        if (!files) {
          this.loading = false;
          this.errors = ["Informe o arquivo"];
          return;
        }

        if (files.length == 0) {
          this.loading = false;
          this.errors = ["Informe o arquivo"];
          return;
        }

        const allowedMimes = [
          "text/csv", //(official)
          "application/vnd.ms-excel", //(official)
          "application/msexcel",
          "application/x-msexcel",
          "application/x-ms-excel",
          "application/x-excel",
          "application/x-dos_ms_excel",
          "application/xls",
          "application/x-xls",
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", //xlsx
        ];

        for (const file of files) {
          if (!allowedMimes.includes(file.type)) {
            this.loading = false;
            this.errors = ["Formato de arquivo inválido"];
            return;
          }

          var limitSize = 10 * 1024 * 1024;

          if (file.size > limitSize) {
            this.loading = false;
            this.errors = ["Suportado até 10MB"];
            return;
          }

          formData.append("file", file);
          formData.append(
            "finance_configuration_account_id",
            finance_configuration_account_id
          );
        }

        let response = await api.post(
          "/rest-home/financial/launch/list-import",
          formData
        );

        let { error, errors, message } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          toast(message, "success");
          this.$emit("success");
        }

        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.log(error);
      }
    },
  },
};
</script>
